import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28e85f00&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=28e85f00&prod&lang=stylus&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=28e85f00&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e85f00",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserInfo: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/UserInfo/index.vue').default})
